var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrInstantBonuses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.053.538L12 .492l-.053.046H4.71L.332 6.37 12 19.496 23.667 6.371 19.292.538h-7.24zm-1.439 1.166h-4.85l.765 3.575 4.085-3.575zM7.72 5.788h8.562L12 2.042 7.72 5.788zm9.752-.51l-4.085-3.574h4.851l-.766 3.575zm-5.47 11.787l4.902-10.11H7.098L12 17.064zm2.132-1.725L18.2 6.954h3.388l-7.454 8.386zm4.422-9.552h3.216L19.27 2.453l-.715 3.335zM4.731 2.453l.714 3.335H2.23l2.502-3.335zM9.867 15.34L2.413 6.954h3.388l4.066 8.387z"
  })));
}
SvgPrInstantBonuses.displayName = 'PrInstantBonuses';
export default SvgPrInstantBonuses;